export class AwsSecretsManagerRefInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "arn",
            "baseName": "arn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsSecretsManagerRefInput.attributeTypeMap;
    }
    constructor() {
    }
}
